import { createContext, useContext, useState, useCallback, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const AdminLoadingContext = createContext(null);

export function AdminLoadingProvider({ children }) {
  const location = useLocation();
  const [readyPath, setReadyPath] = useState(null);

  // We consider the route loading if the current pathname doesn't match the readied pathname
  const isRouteLoading = readyPath !== location.pathname;

  const currentPathRef = useRef(location.pathname);
  currentPathRef.current = location.pathname; // Update directly during render

  const markAdminPageReady = useCallback((path) => {
    // Only accept readiness signals for the CURRENT route
    if (path === currentPathRef.current) {
      setReadyPath(path);
    }
  }, []);

  return (
    <AdminLoadingContext.Provider value={{ isRouteLoading, markAdminPageReady }}>
      {children}
    </AdminLoadingContext.Provider>
  );
}

export function useAdminPageReady() {
  const context = useContext(AdminLoadingContext);
  if (!context) {
    throw new Error('useAdminPageReady must be used within an AdminLoadingProvider');
  }
  return context;
}
